import bookingCollectionSelectors from './bookingCollectionSelectors';
import resourcesSelectors from './resourcesSelectors';
import alternativesSelectors from './alternativesSelectors';

export default {
  ...resourcesSelectors,
  ...alternativesSelectors,
  ...bookingCollectionSelectors
};
